import React, { PureComponent } from 'react';
import PageTitle from '../../components/PageTitle';
import FeaturesComparison from '../../components/FeaturesComparison';

import { DEFAULT_PACKAGE_TYPES, DEFAULT_PACKAGES } from '../../constants/main';

import {
    packageSectionsTransform,
    getNewPackageAndPricingOverrides,
} from './utils';
import defaultSettings from './settings';
import userSettings from './userSettings';
import {
    COMPARE_PACKAGE_CTA_ACTION,
    GA_P1_LABEL,
    GA_P2_LABEL,
    GA_P3_LABEL,
} from '../../constants/analytics';
import { PACKAGE_COMPARISON_PAGE } from '../../constants/main';
import { loadCrazyEgg } from '../utils';
import { pageConnector } from '../connector';
import { shouldShowPricingAndPackagingContent } from '../../components/pricingAndPackagingUtils';

class PackageComparisonPage extends PureComponent {
    componentDidMount() {
        loadCrazyEgg();
    }

    render() {
        const {
            locale,
            isAuthenticated,
            feeBreakdown,
            assortmentsTax,
            selectedPackage,
            clearSelectedPackage,
            redirectToEssentials,
            redirectToProfessional,
            redirectToPremium,
            userPlan,
            packageTitles,
            cappedFeeExperimentFeatureFlag,
            assortmentsAvailability,
            launchNewPackageAndPricing,
            tld,
        } = this.props;

        const showPricingAndPackagingContent =
            shouldShowPricingAndPackagingContent();

        const {
            feeBreakdownOverride,
            packagesOverride,
            packageTypesOverride,
            defaultSettingsOverride,
        } = getNewPackageAndPricingOverrides({
            tld,
            launchNewPackageAndPricing,
            feeBreakdown,
            defaultSettings,
            packages: DEFAULT_PACKAGES,
            packageTypes: DEFAULT_PACKAGE_TYPES,
            isAuthenticated,
            userPlan,
            showPricingAndPackagingContent,
        });

        const { current: { version: packageVersion } = {} } =
            assortmentsAvailability || {};

        const {
            primaryHeading,
            paymentProcessingFeature,
            sections,
            CTAs,
            CTAStyles,
            pricePerFreeTicket,
            showMaxFee,
        } = packageSectionsTransform({
            locale,
            isAuthenticated,
            userPlan,
            packageVersion,
            defaultSettings: defaultSettingsOverride,
            page: PACKAGE_COMPARISON_PAGE,
            userSettings,
            additionalSettings: launchNewPackageAndPricing
                ? defaultSettingsOverride
                : null,
            launchNewPackageAndPricing,
        });

        let getStartedActions = [
            redirectToProfessional.bind(
                null,
                COMPARE_PACKAGE_CTA_ACTION,
                GA_P2_LABEL,
            ),
            redirectToPremium.bind(
                null,
                COMPARE_PACKAGE_CTA_ACTION,
                GA_P3_LABEL,
            ),
        ];

        // If user is not apart of new pricing and packaging changes, add the essentials package actions
        if (!launchNewPackageAndPricing) {
            getStartedActions.unshift(
                redirectToEssentials.bind(
                    null,
                    COMPARE_PACKAGE_CTA_ACTION,
                    GA_P1_LABEL,
                ),
            );
        }

        if (showPricingAndPackagingContent) {
            getStartedActions = [
                () => {
                    window.location.href =
                        '/signin/signup/?referrer=%2Fmanage%2Fevents%2Fcreate%2F';
                },
                () => {
                    window.location.href = '/contact-sales/';
                },
            ];
        }

        return (
            <div className="eds-bg-color--white">
                <PageTitle title={packageTitles.comparePackages} />
                <FeaturesComparison
                    locale={locale}
                    feeBreakdown={feeBreakdownOverride}
                    assortmentsTax={assortmentsTax}
                    primaryHeading={primaryHeading}
                    paymentProcessingFeature={paymentProcessingFeature}
                    sections={sections}
                    selectedPackage={selectedPackage}
                    getStartedActions={getStartedActions}
                    clearSelectedPackage={clearSelectedPackage}
                    showMaxFee={showMaxFee}
                    CTAs={CTAs}
                    CTAStyles={CTAStyles}
                    pricePerFreeTicket={pricePerFreeTicket}
                    shouldShowCappedFee={cappedFeeExperimentFeatureFlag}
                    packages={packagesOverride}
                    packageTypes={packageTypesOverride}
                    launchNewPackageAndPricing={launchNewPackageAndPricing}
                />
            </div>
        );
    }
}

export default pageConnector(PackageComparisonPage);
